<template>
  <div>
    <b-modal
        if="entityModalSelect"
        ref="entityModalSelect"
        :size="size"
        @ok="handleOk">
      <!--                :title="selectFrom"-->
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter ref="emFilter"
                           :entity="selectFrom" :with-pagination="showType !=='tree'"
                           :$_em-custom-vuex-mixin_entity="customVuexEntity"
                           :$_em-custom-vuex-mixin_filter="customVuexFilter"
                           :$_em-custom-vuex-mixin_vo="customVuexVo"
                           :query-api="queryApi"
                           is-pop-modal
                           @showEntityModalSelect="handleShowSubEntityModalSelectByFilter"/>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emMenuResultTable" class="content">
        <div class="card my-1">
          <div
              id="collapseTwo"
              class="collapse show"
              aria-labelledby="headingTwo"
              data-parent="#accordionResult">
            <div class="card-body">
              <em-table ref="emTable" v-if="showType==='table'"
                        :entity="selectFrom"
                        :selectActionEnable="!checkTempEnable"
                        :checkboxColumnDisabled="!checkTempEnable"
                        inline-actions-disabled
                        editDisable isModal exportDisabled
                        :modal-check-enable="checkTempEnable"
                        :$_em-custom-vuex-mixin_entity="customVuexEntity"
                        :$_em-custom-vuex-mixin_filter="customVuexFilter"
                        :$_em-custom-vuex-mixin_vo="customVuexVo"
                        :query-api="queryApi"
                        @entitySelected="handleEntitySelected"></em-table>
              <EmZTree ref="imfTree" v-else-if="showType==='tree'" :tree-nodes="treeNodes"
                       :multi-select="multiSelect" checkEnable chkbox-type="{'Y': '', 'N': ''}"
              ></EmZTree>
            </div>
          </div>
        </div>
      </div>
      <!-- <slot></slot> -->
    </b-modal>
    <!--    最多递归2层-->
    <em-modal-entity-selector v-if="level < 2 " ref="emModalEntitySelector" :id="'entityModalSelect-'+level"
                              :level="level+1"></em-modal-entity-selector>
  </div>
</template>

<script>
import EmFilter from "@/components/em/EmFilter";
import EmTable from "@/components/em/EmTable";
import EmModalEntitySelector from "@/components/em/EmModal/EntitySelector";
import EmZTree from "@/components/em/EmZTree";
import EmUtils from "@/utils/emUtils"

export default {
  name: "em-modal-entity-selector",
  components: {EmTable, EmFilter, EmModalEntitySelector, EmZTree},
  props: {
    size: {
      type: String,
      default: "lg"
    },
    level: {
      type: Number,
      default: 1
    },
    checkEnable: {
      type: Boolean,
      default: false
    },
    needCheckedRows: {
      type: Boolean,
      default: false
    },
    disableAutoClearWhenCheckFinish: {
      type: Boolean,
      default: false
    },
    disableStore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //从哪个entity进行选择
      selectFrom: "emMenuType",
      //选择的结果写入哪个vuex.model
      selectTo: "",
      subModalSelectorEntity: 'emMenuType',
      selectedItem: {},
      popCol: {},
      popRow: {},
      popBy: "",
      showType: "table",
      multiSelect: false,
      type: "",
      modalMultiSelectedType:"string",
      customVuexName: undefined,//后端取的名字
      tagNum: 1,//利用公倍数来控制vuex的生效，不设置则都不生效
      checkTempEnable: false,
      queryApi: undefined
    };
  },
  computed: {
    customVuexEntity() {
      return this.generateCustomVuexName('Entity', 2);//tagNum为2的倍数时生效
    },
    customVuexFilter() {
      return this.generateCustomVuexName('Filter', 3);//tagNum为3的倍数时生效
    },
    customVuexVo() {
      return this.generateCustomVuexName('Vo', 5);//tagNum为5的倍数时生效
    },
    treeNodes() {
      return this.$store.state[this.selectFrom][this.customVuexVo ? this.customVuexVo : "rows"]
    }
  },
  watch: {
    checkEnable: {
      handler() {
        this.checkTempEnable = this.checkEnable;
      },
      immediate: true
    }
  },
  methods: {
    handleOk() {
      if (this.checkTempEnable) {
        this.handleMultipleEntitySelect();
      } else {
        //table直接点击ok,就等于选择了null,可以清空相应内容
        if (this.showType === 'table') {
          this.handleEntitySelected(null);
        }//tree,就需要取选中行了
        else if (this.showType === 'tree') {
          let checkedNode = this.$refs.imfTree.getCheckedNodes()[0];
          this.handleEntitySelected(checkedNode);
        }
      }
    },
    getMutationName() {
      let popBy_cap_first = EmUtils.toCapFirst(this.popBy)
      switch (this.popBy) {
        case 'editRow': {
          return `${this.selectTo}/setRow`
        }
        case 'newRow': {
          return `${this.selectTo}/setNewRow`
        }
        default: {
          return `${this.selectTo}/set${popBy_cap_first}Attribute`
        }
      }
    },
    popColNeedSet() {
      return this.popCol && this.popCol.key && this.popCol.form
    },
    handleEntitySelected(selectedItem) {
      console.log("selected item is", selectedItem)
      console.log("popCol is", this.popCol)
      // console.log("correspondingField is", this.popCol.form.correspondingField)
      if (!this.disableStore) {
        //根据popBy决定设置vuex中的哪项数据:
        let mutationName = this.getMutationName();
        //如果要设置filter,后缀需要设置为Filter
        let suffix = this.popBy === "filter" || this.popBy.endsWith("Filter") ? "Filter" : "";
        //获取其他绑定字段
        let fieldsBindingObj = this.popCol.form.fieldsBindingByEntityModalSelected ?
            JSON.parse(this.popCol.form.fieldsBindingByEntityModalSelected) : null
        //selectedItem为空，就清空相应的attribute
        if (this.popColNeedSet()) {
          if (selectedItem === null) {
            console.log("did not selected anything")
            //清空他自己
            this.$store.commit(mutationName, {
              key: this.popCol.key,
              newValue: null,
              row: this.popRow
            })
            //清空其他绑定字段
            if (fieldsBindingObj) {
              Object.getOwnPropertyNames(fieldsBindingObj).forEach((key) => {
                this.$store.commit(mutationName, {
                  key: key + suffix,
                  newValue: null,
                  row: this.popRow
                })
              })
            }
          } else {
            //给自己赋值：如果model的fieldConfig中有form.correspondingField并且在selectedItem中也有同名属性，就赋值
            if (this.popCol.form.correspondingField && selectedItem[this.popCol.form.correspondingField]) {
              this.$store.commit(mutationName, {
                key: this.popCol.key,
                newValue: selectedItem[this.popCol.form.correspondingField],
                row: this.popRow
              })
            }
            //给其他绑定字段赋值
            if (fieldsBindingObj) {
              Object.getOwnPropertyNames(fieldsBindingObj).forEach((key) => {
                this.$store.commit(mutationName, {
                  key: key + suffix,
                  newValue: selectedItem[fieldsBindingObj[key]],
                  row: this.popRow
                })
              })
            }
          }
        }
      }
      //向外触发事件
      this.$emit("entityModalSelectSelected", selectedItem);
      this.$nextTick(() => {
        // Wrapped in $nextTick to ensure DOM is rendered before closing
        this.hideModal()
      });
    },
    showModal(selectTo, popBy, popCol, popRow) {
      console.log("show modal", popCol)
      this.checkTempEnable = false;//check disable
      this.setLocData(selectTo, popBy, popCol, popRow)
      this.$refs['entityModalSelect'].show();
    },
    getShowType(type) {
      console.log("getShowType:", type)
      if (type === 'treeSelect' || type === 'treeSelectMultiple') {
        return 'tree'
      } else if (type === 'entityModalSelect' || type === 'entityModalMultipleSelect') {
        return 'table'
      }
      return 'table'
    },
    getMultiSelect(type) {
      console.log("getShowType:", type)
      if (type === 'entityModalMultipleSelect' || type === 'treeSelectMultiple') {
        return true
      }
      return false
    },
    hideModal() {
      this.$refs['entityModalSelect'] && this.$refs['entityModalSelect'].hide();
    },
    handleShowSubEntityModalSelectByFilter({popCol} = {}) {
      //本身的selectFrom就变成了subEntityModalSelect的selectTo
      this.$refs.emModalEntitySelector.showModal(this.selectFrom, 'filter', popCol, null)
    },
    setCustomVuexConfig(selectFrom, customVuexName, tagNum, queryApi) {
      this.selectFrom = selectFrom;
      this.customVuexName = customVuexName;
      this.tagNum = tagNum ? tagNum : 5;//默认只有vo生效
      this.queryApi = queryApi;
    },
    onlyShowModal() {
      this.$refs['entityModalSelect'].show();
    },
    generateCustomVuexName(withEnd, divisor) {
      if (this.tagNum % divisor === 0) {//取余为零时生效
        return this.customVuexName ? this.customVuexName + withEnd : undefined;
      }
    },
    /**
     * @see #setCustomVuexConfig
     * must after selectFrom been set and modal showed up
     * @param something
     */
    doSomethingWithFiler(something) {
      console.log(this.$refs.emFilter);
      something(this.$refs.emFilter);
    },
    handleMultipleEntitySelect() {
      let selectedItems
      let selectedIds
      let selectedIdList
      if (this.showType === 'table') {
        selectedIdList = this.$refs.emTable.checkedItems;
        selectedIds = this.$refs.emTable.checkedItems.join(",");
        selectedItems = this.$refs.emTable.checkedItemsRows
      } else if (this.showType === 'tree') {
        selectedItems = this.$refs.imfTree.getCheckedNodes()
        selectedIdList = selectedItems.map(m => m.id)
        selectedIds = selectedIdList.join(",")
      }
      console.log("selectedIds: ", selectedIds)
      console.log("selectedItems: ", selectedItems)
      console.log(this.popCol)
      //根据popBy决定设置vuex中的哪项数据:
      let mutationName = this.getMutationName()
      //selectedIds为空，就清空相应的attribute
      if (this.popColNeedSet()) {
        if (selectedIds === null || selectedIds === '') {
          //清空他自己
          this.$store.commit(mutationName, {
            key: this.popCol.key,
            newValue: null,
            row: this.popRow
          })
        } else {
          //给自己赋值
          if (this.popCol.form.correspondingField) {
            this.$store.commit(mutationName, {
              key: this.popCol.key,
              newValue: this.modalMultiSelectedType === 'list' ? selectedIdList : selectedIds,
              row: this.popRow
            })
          }
        }
      }
      this.$emit('checkFinish', this.needCheckedRows ? this.$refs.emTable.checkedItemsRows : this.modalMultiSelectedType === 'list' ? selectedIdList : selectedIds);
      if (!this.disableAutoClearWhenCheckFinish && this.showType === 'table') {
        this.$refs.emTable.checkedItems = [];
      }
      this.$nextTick(() => {
        this.hideModal()
      });
    },
    showMultipleModal(selectTo, popBy, popCol, popRow) {
      this.checkTempEnable = true;//check enable
      this.setLocData(selectTo, popBy, popCol, popRow)
      this.$refs['entityModalSelect'].show();
    },
    setLocData(selectTo, popBy, popCol, popRow) {
      this.selectTo = selectTo
      this.popBy = popBy
      this.popCol = popCol
      this.selectFrom = popCol.form.entity
      this.popRow = popRow
      //判断是tree还是table
      this.showType = this.getShowType(popCol.form.type)
      this.type = popCol.form.type
      this.modalMultiSelectedType = popCol.form.modalMultiSelectedType
      this.multiSelect = this.getMultiSelect(popCol.form.type)
    },
  },
}
;
</script>
